import React, { useEffect, useRef } from 'react'

import type { ToastLike } from '@mangovoice/mango-ui'

import type { SwitchboardTranslateFn } from '../types'
import { text } from '../utils/text'

export interface FixedHandleRouteConflictToastProps {
  descriptions: string[]
  extensionDialPlan: number
  toast?: ToastLike
  t?: SwitchboardTranslateFn
}

export const FixedHandleRouteConflictToast: React.FC<
  FixedHandleRouteConflictToastProps
> = ({ descriptions, extensionDialPlan, toast, t }) => {
  const hasShownForCurrentConflictRef = useRef(false)

  useEffect(() => {
    if (descriptions.length === 0) {
      hasShownForCurrentConflictRef.current = false
      return
    }

    if (!toast || hasShownForCurrentConflictRef.current) {
      return
    }

    hasShownForCurrentConflictRef.current = true
    toast.create({
      id: `switchboard-route-conflict-${extensionDialPlan}`,
      title: text(
        t,
        'switchboard.edit.routeConflict.title',
        'Routing conflict',
      ),
      description: descriptions.join(' '),
      type: 'error',
      duration: Infinity,
      closable: true,
    })
  }, [descriptions, extensionDialPlan, t, toast])

  return null
}
